import { apiService } from './api';

export type DealDocumentType = 'bill_of_sale' | 'tila';

/**
 * Downloads a generated contract document for a deal through the
 * authenticated API client (the only real route is under /deal-contracting).
 *
 * Note: apiService.get already unwraps axios' response.data, so with
 * responseType 'blob' it resolves directly to the Blob.
 */
export async function downloadDealDocuments(
  dealId: string,
  type: DealDocumentType = 'bill_of_sale'
): Promise<void> {
  const blob = await apiService.get<Blob>(
    `/deal-contracting/${dealId}/documents/download?type=${type}`,
    { responseType: 'blob' }
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `deal-${dealId}-${type}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
